import { DEFAULT_CONFIG } from "./config.default";
import { ConfigDataType } from "./config.interface";
const dBType: any = process.env[`APP_DB_TYPE`] || DEFAULT_CONFIG.database.type;
const gtsDBType:any=process.env[`INA_DB_TYPE`] || DEFAULT_CONFIG.gtsDatabase.type;

export default (): ConfigDataType => ({
    env: process.env[`APP_ENV`] || DEFAULT_CONFIG.env,
    selfHost: process.env[`APP_SERVER_PORT`] ? process.env[`APP_LOGGING_MODE`] : DEFAULT_CONFIG.selfHost,
    port: process.env[`APP_SERVER_PORT`] ? parseInt(process.env[`APP_SERVER_PORT`], 10) : DEFAULT_CONFIG.port,
    logLevel: process.env[`APP_LOGGING_MODE`] || DEFAULT_CONFIG.logLevel,
    maxPayloadSize: process.env[`APP_MAX_PAY_LOAD_SIZE`] || DEFAULT_CONFIG.maxPayloadSize,
    responseTimeOut: process.env[`APP_RESPONSE_TIME_OUT`] ? parseInt(process.env[`APP_RESPONSE_TIME_OUT`]) : DEFAULT_CONFIG.responseTimeOut,
    staticFilesFolder: process.env[`APP_FILES_STORE_FOLDER_NAME`] || DEFAULT_CONFIG.staticFilesFolder,
    database: {
        type: dBType,
        host: process.env[`APP_DB_HOST`] || DEFAULT_CONFIG.database.host,
        port: parseInt(process.env[`APP_DB_PORT`]) || DEFAULT_CONFIG.database.port,
        username: process.env[`APP_DB_USER`] || DEFAULT_CONFIG.database.username,
        password: process.env[`APP_DB_PASS`] || DEFAULT_CONFIG.database.password,
        dbName: process.env[`APP_DB_DBNAME`] || DEFAULT_CONFIG.database.dbName,
        poolLimit: parseInt(process.env[`APP_DB_POOL_LIMIT`]) || DEFAULT_CONFIG.database.poolLimit,
        charset: process.env[`APP_DB_CHARSET`] || DEFAULT_CONFIG.database.charset,
    },
    gtsDatabase: {
        type: gtsDBType,
        host: process.env[`GTS_DB_HOST`] || DEFAULT_CONFIG.gtsDatabase.host,
        port: parseInt(process.env[`GTS_DB_PORT`]) || DEFAULT_CONFIG.gtsDatabase.port,
        username: process.env[`GTS_DB_USER`] || DEFAULT_CONFIG.gtsDatabase.username,
        password: process.env[`GTS_DB_PASS`] || DEFAULT_CONFIG.gtsDatabase.password,
        dbName: process.env[`GTS_DB_DBNAME`] || DEFAULT_CONFIG.gtsDatabase.dbName,
        poolLimit: parseInt(process.env[`GTS_DB_POOL_LIMIT`]) || 20,
        charset: process.env[`GTS_DB_CHARSET`] || DEFAULT_CONFIG.database.charset,
    },
    rateLimiting: {
        ttl: parseInt(process.env['APP_THROTTLE_TTL']) || DEFAULT_CONFIG.rateLimiting.ttl,
        limit: parseInt(process.env['APP_THROTTLE_LIMIT']) || DEFAULT_CONFIG.rateLimiting.limit,
        maxLoginAttempts: parseInt(process.env['APP_THROTTLE_MAX_LOGINS']) || DEFAULT_CONFIG.rateLimiting.maxLoginAttempts,
    },
    appSepcific: {
        considerMarginDate: process.env['DATA_FETCH_MARGIN_DATE'] == "true"
    }
});